/* NR · Bloque de canales — gesto de wayfinding «Ping localizador» (spec-adn-visual §5).
   El botón «Chatear con Bruno» NO abre el chat: Wizybot no expone open() y su widget ignora los
   clics sintéticos (isTrusted). Al clic REAL, dibujamos un anillo amarillo one-shot + etiqueta
   SOBRE el lanzador de Wizybot (nunca tocamos su iframe) para guiar el ojo. Overlay posicionado
   (position:fixed) → coordenadas de viewport vía getBoundingClientRect. Una sola vez por clic;
   se limpia solo. La animación (y su degradado con prefers-reduced-motion) vive en el CSS. */
(function () {
  'use strict';

  // Idempotencia: la sección inyecta el <script> inline → una placa por render (editor de temas /
  // 2ª colocación) acumularía listeners. Un solo binding en todo el documento.
  if (window.__nrCanalesPingBound) return;
  window.__nrCanalesPingBound = true;

  // Selectores del lanzador de Wizybot, del más específico al más laxo (verificar en vivo).
  var LAUNCHER_SELECTORS = [
    '#WizybotShopifyWidget__iframe__outter__id',
    '[id^="WizybotShopifyWidget"]',
    '[id*="Wizybot"]',
    'iframe[src*="wizybot"]',
    '.wizybot-widget',
    '.wizybot-launcher'
  ];

  function findLauncher() {
    for (var i = 0; i < LAUNCHER_SELECTORS.length; i++) {
      var el = document.querySelector(LAUNCHER_SELECTORS[i]);
      if (el) {
        var r = el.getBoundingClientRect();
        // Un lanzador visible tiene tamaño real y vive en pantalla.
        if (r.width > 8 && r.height > 8) return r;
      }
    }
    return null;
  }

  // Rectángulo de respaldo: la esquina inferior derecha, donde vive el widget por defecto.
  function fallbackRect() {
    var d = 60;
    var margin = 24;
    var left = window.innerWidth - margin - d;
    var top = window.innerHeight - margin - d;
    return { left: left, top: top, width: d, height: d,
             right: left + d, bottom: top + d };
  }

  function clearPing() {
    var old = document.querySelectorAll('.nrbruno-ping, .nrbruno-ping__label');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
  }

  function ping(label) {
    clearPing();

    var rect = findLauncher() || fallbackRect();
    var cx = rect.left + rect.width / 2;
    var cy = rect.top + rect.height / 2;
    // El diámetro del anillo sigue al tamaño del lanzador (con un piso legible).
    var d = Math.max(48, Math.min(rect.width, rect.height));

    var wrap = document.createElement('div');
    wrap.className = 'nrbruno-ping';
    wrap.style.setProperty('--nrbp-x', cx + 'px');
    wrap.style.setProperty('--nrbp-y', cy + 'px');
    wrap.style.setProperty('--nrbp-d', d + 'px');
    wrap.innerHTML =
      '<span class="nrbruno-ping__glow"></span>' +
      '<span class="nrbruno-ping__ring"></span>' +
      '<span class="nrbruno-ping__ring nrbruno-ping__ring--2"></span>';

    // Etiqueta a la izquierda del lanzador (queda dentro de la pantalla en la esquina derecha).
    var tag = document.createElement('div');
    tag.className = 'nrbruno-ping__label';
    tag.textContent = label || 'Aquí está Bruno';
    // La etiqueta crece hacia la izquierda (transform translate(-100%)) desde 12px antes del
    // lanzador. Clamp para que no se salga por el borde izquierdo si el lanzador estuviera a la izq.
    var lx = Math.max(120, rect.left - 12);
    tag.style.setProperty('--nrbp-lx', lx + 'px');
    tag.style.setProperty('--nrbp-ly', cy + 'px');

    document.body.appendChild(wrap);
    document.body.appendChild(tag);

    // Limpieza tras el ciclo (una sola vez; el amarillo es escaso).
    window.setTimeout(clearPing, 2400);
  }

  function onClick(e) {
    var btn = e.target.closest('[data-nr-bruno-ping]');
    if (!btn) return;
    e.preventDefault();
    ping(btn.getAttribute('data-nr-bruno-label'));
  }

  // Delegación en el documento → funciona aunque la sección se recargue en el editor de temas.
  document.addEventListener('click', onClick);
})();
